import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, RequestMethod } from '@angular/common/http';

import {UserManagerProvider} from '../user-manager/user-manager'
import {StorageManagerProvider} from '../storage-manager/storage-manager';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggerService } from '../../app/services/logger.service';

/*
  Generated class for the AjaxBridgeProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class AjaxBridgeProvider {
   
//  public static http : Http;
    public ajaxControllerServerUrl;
    public ajaxRescueUrl;
    public ajaxResetPassUrl;
  constructor( public  http : HttpClient, 
    public logger: LoggerService,
                public storageManager : StorageManagerProvider) {
//    this.logger.debug('Hello AjaxBridgeProvider Provider');
    this.ajaxControllerServerUrl = 'https://server1.bayadic.com/site/loghatnameh/autoPost/bayadicapi/controllers.php';
    this.ajaxRescueUrl = 'https://bayadic.com/rescue/system/RescueLeader.php';
    this.ajaxResetPassUrl = 'https://bayadic.com/rescue/system/security/ResetPassword.php';
    this.storageManager.get("ajaxUrl").then(ajaxUrl=>{
        let webAjaxUrl = <string>ajaxUrl;
        if(webAjaxUrl !=undefined)
            this.ajaxControllerServerUrl = webAjaxUrl;
    })
//    this.ajaxControllerServerUrl = 'http://localhost/mobile/bayadicapi/controllers.php';
  }

  rescue(version: string) {
//      var self = this;
//      let loading = this.loadingCtrl.create({
//          content: 'لطفا کمی صبر کنید ....'
//      });
//      loading.present();
      return new Promise((resolve,reject) =>{
        let result: string;
        let postParams = {
          version: version
        }
        // var headers = new Headers();
        // headers.append("Accept", 'application/json');
        // headers.append('Content-Type', 'application/json' );
        // // let options = new RequestOptions({ headers: headers,   method: RequestMethod.Post });
        
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Accept': 'application/json'
          })
        };
        
        this.http.post(this.ajaxRescueUrl, postParams, httpOptions)
           .subscribe(data => {
            //this.logger.debug(data['_body']);
                result = data['_body'];
                result = result.trim();
                resolve(result);
//                loading.dismiss();
                
           }, error => {
                reject(error);
          });
      });
  }
  resetPassword(email: string) {
//      var self = this;
//      let loading = this.loadingCtrl.create({
//          content: 'لطفا کمی صبر کنید ....'
//      });
//      loading.present();
      return new Promise((resolve,reject) =>{
        let result: string;
        let postParams = {
          email: email
        }
        // var headers = new Headers();
        // headers.append("Accept", 'application/json');
        // headers.append('Content-Type', 'application/json' );
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Accept': 'application/json'
          })
        };
        
        // let options = new RequestOptions({ headers: headers,   method: RequestMethod.Post });
        this.http.post(this.ajaxResetPassUrl, postParams, httpOptions)
           .subscribe(data => {
            //this.logger.debug(data['_body']);
                result = data['_body'];
                result = result.trim();
                resolve(result);
//                loading.dismiss();
                
           }, error => {
                reject(error);
          });
      });
  }
  query(action: string, CallBackFunction?: Function,  data?:Object) {
        let result: string;
        let outData: Object;
        let postParams = {
          action: action,
          data: data
        }
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Accept': 'application/json'
          })
        };

        this.http.post(this.ajaxControllerServerUrl, postParams, httpOptions)
           .subscribe(data => {
                result = data['_body'];
                outData = JSON.parse(result);
                if(CallBackFunction)
                    CallBackFunction(outData);
           }, error => {
            this.logger.debug(error);// Error getting the data
                outData = error;
          });
          
        return outData;
  }

}
